






import { Component, Vue } from 'vue-property-decorator';
import Browser from './components/Browser.vue';

@Component({
  components: {
    Browser,
  },
})
export default class App extends Vue {}
